import { render } from "./OrganicTimeSeriesDashboard.vue?vue&type=template&id=90d55b0e"
import script from "./OrganicTimeSeriesDashboard.vue?vue&type=script&lang=js"
export * from "./OrganicTimeSeriesDashboard.vue?vue&type=script&lang=js"

import "./OrganicTimeSeriesDashboard.vue?vue&type=style&index=0&id=90d55b0e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__